import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileSmallHeadingControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setTextsHeight(element);
    }

}

const mobileSmallHeadingControlView = new MobileSmallHeadingControlView();
export default mobileSmallHeadingControlView;